import React from 'react'
import aboutimage from "./images/plant.jpg"

export default function About() {
  return (
    <div>
    <div className="container ">
    <h4 className='headline card'>Who <span>are</span> we ?</h4>
      
         <div className='flex   aboutsection'>
        
       <p className="abouttext">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Unde cupiditate totam temporibus odio voluptatibus, <br/>in culpa officiis expedita consequatur modi atque nam
         dolorum sint quo ipsum eligendi voluptate ducimus, illo perferendis <br/> consectetur! Quia perferendis temporibus,
        ratione nam autem consequatur eligendi sint harum illo corporis saepe vero voluptates dolores error fuga.</p>
        </div>

        <div className=" flex  aboutimages">
          <img src={aboutimage} alt="coffeeimage" className="aboutpic" height="250px" />
        
        
        </div>

     
    </div>
    <br/> <br/> <br/> <br/> 
    </div>
  )
}
